<script setup>
  import { computed } from "vue";
  import { Label } from "@/components/ui/label";
  import { Switch } from "@/components/ui/switch";
  import { Select } from "@/components/episto-ui/select";

  const props = defineProps({
    cardToken: {
      type: String,
      default: null,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    targetId: {
      type: [Number, String],
      default: null,
    },
    groupToken: {
      type: String,
      default: null,
    },
    targetOptions: {
      type: Array,
      default: () => [],
    },
    populationOptions: {
      type: Array,
      default: () => [],
    },
    hasReportDefault: {
      type: Boolean,
      default: false,
    },
  });

  defineEmits(["update:hasFilter", "update:targetId", "update:groupToken"]);

  const targetSelectOptions = computed(() =>
    props.targetOptions.map((t) => ({
      value: t.value.toString(),
      label: t.label,
    })),
  );

  const populationSelectOptions = computed(() =>
    props.populationOptions.map((g) => ({
      value: g.value,
      label: g.label,
    })),
  );
</script>

<template>
  <div v-if="cardToken">
    <div class="flex items-center gap-2">
      <Switch
        :model-value="hasFilter"
        @update:model-value="$emit('update:hasFilter', $event)" />
      <Label class="text-sm">{{ hasReportDefault ? "Override report-level filters" : "Filter respondents" }}</Label>
    </div>

    <div
      v-if="hasFilter"
      class="mt-3 space-y-3">
      <div class="w-1/2 min-w-0">
        <Label class="text-xs text-muted-foreground">Target</Label>
        <Select
          :model-value="targetId?.toString() || undefined"
          :options="targetSelectOptions"
          placeholder="All targets"
          class="mt-1"
          @update:model-value="$emit('update:targetId', $event ? parseInt($event) : null)" />
      </div>

      <div class="w-1/2 min-w-0">
        <Label class="text-xs text-muted-foreground">Group</Label>
        <Select
          :model-value="groupToken || undefined"
          :options="populationSelectOptions"
          placeholder="All respondents"
          class="mt-1"
          @update:model-value="$emit('update:groupToken', $event || null)" />
      </div>
    </div>
  </div>
</template>
